export const studioIntegrationHeaderStyles = {
  display: 'flex',
  gap: 4,
  alignItems: 'center',
};
